export const RECOMMENDATION_PREFERENCES = 'WebApp.RecommendationUI.Preferences';
export const RECOMMENDATION_PREFERENCES_ACCOUNT_LEVEL = 'WebApp.RecommendationUI.AccountLevelPreferences';
export const CAMPAIGN_TYPES = {
  DismissFeedback: 'DismissFeedback',
  RejectAutoApplySuggestedAds: 'RejectAutoApplySuggestedAds',
};

export const PREFERENCES_ACTION_TYPES = {
  HidedRecommendationCards: 'HidedRecommendationCards',
  HidedRecommendationBanner: 'HidedRecommendationBanner',
  AutoRefresh: 'AutoRefresh',
  OptimizationScoreOnboard: 'OptimizationScoreOnboard',
  AAROnBoard: 'AAROnBoard',
};

export const IN_PRODUCT_UPDATE_RECOMMENDATIONS_VIEW_TIME = {
  FirstViewTime: 'FirstViewTime',
};
